import { ApolloError, ServerError } from '@apollo/client';

function selectError(error: ApolloError | Error) {
  const { graphQLErrors, networkError } = error as ApolloError;

  if (graphQLErrors && graphQLErrors.length) {
    // NOTE: In some cases the error message is on the "error" field
    return graphQLErrors[0];
  }

  if (networkError) {
    // NOTE: In some cases the correct error is inside of networkError.result.errors
    // Sometimes a unique constraint violation from a GraphQL error might show up here
    // https://github.com/apollographql/apollo-client/issues/2810#issuecomment-654226300
    const { result } = networkError as ServerError;
    const serverError = result?.errors?.length ? result.errors[0] : null;

    return serverError || networkError;
  }

  return error;
}

export function getErrorCode(error: ApolloError | Error): string | null | undefined {
  const selectedError = selectError(error);

  // Prioritize custom exception code over GraphQL error code
  return selectedError?.extensions?.exception?.code || selectedError?.extensions?.code;
}

export function getErrorMessage(error: ApolloError | Error, fallbackMessage?: string): string {
  const selectedError = selectError(error);

  return selectedError.message || fallbackMessage || 'An unexpected error has occured.';
}
